angular.module('templates-main', ['../app/components/htmlTemplates/treeTemplate.html']);

angular.module('../app/components/htmlTemplates/treeTemplate.html', []).run(['$templateCache', function($templateCache) {
    $templateCache.put('../app/components/htmlTemplates/treeTemplate.html',
        '<ul {{options.ulClass}}>\n' +
    '    <li ng-repeat="node in node.{{options.nodeChildren}} | filter:filterExpression:filterComparator {{options.orderBy}}" ng-class="headClass(node)" {{options.liClass}} set-node-to-data>\n' +
    '        <a class="tree-label {{options.labelClass}}" ng-class="[selectedClass(), unselectableClass()]" ng-click="$event.stopPropagation();selectNodeLabel(node);selectNodeHead(node)"  ng-mouseenter="treeEyes(node,true,$event)" ng-mouseleave="treeEyes(node,false,$event)">\n' +
    '            <i class="iconfont" ng-show="!node.relType" ng-class="iBranchClass()"></i>\n' +
    '            <i class="iconfont" ng-show="node.relType == 1" trs-Tooltip data-placement="auto bottom" data-container="body" title="" ng-class="[iBranchClass(), bindingClass()]"></i>\n' +
    '            <i class="iconfont" ng-show="node.relType == 2" trs-Tooltip data-placement="auto bottom" data-container="body" title="" ng-class="[iBranchClass(), bindingClass()]"></i>\n' +

    '            <div tree-transclude class="treeCustomCon"></div>\n' +
    '        </a>\n' +
    '        <treeitem ng-show="nodeExpanded()"></treeitem>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '');
}]);
